import React from 'react';

import {CheckboxSkeleton, FormSectionSkeleton} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const PitchBookSectionSkeleton = () => (
    <Group direction="v" gap="l" alignItems="start">
        <FormSectionSkeleton labelWidth={170}>
            <Group direction="v" alignItems="start">
                <CheckboxSkeleton labelWidth={158}/>
                <CheckboxSkeleton labelWidth={135}/>
                <CheckboxSkeleton labelWidth={127}/>
            </Group>
        </FormSectionSkeleton>
    </Group>
);
